import { render, staticRenderFns } from "./dialogNoticeStyle2.vue?vue&type=template&id=16b92932&scoped=true&"
import script from "./dialogNoticeStyle2.vue?vue&type=script&lang=js&"
export * from "./dialogNoticeStyle2.vue?vue&type=script&lang=js&"
import style0 from "./dialogNoticeStyle2.vue?vue&type=style&index=0&id=16b92932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b92932",
  null
  
)

export default component.exports